import validate from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/node_modules/nuxt/dist/pages/runtime/validate.js";
import loading_45global from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/middleware/loading.global.ts";
export const globalMiddleware = [
  validate,
  loading_45global
]
export const namedMiddleware = {}